import { RequiredTypeNames } from "@ankaadia/ankaadia-shared";
import type { ProcessStateFragment, ProcessTaskFragment } from "@ankaadia/graphql";
import type { PossibleTypesMap } from "@apollo/client/core";

export const possibleApolloReturnTypes: PossibleTypesMap = {
  ProcessTask: RequiredTypeNames<ProcessTaskFragment>()([
    "ProcessTaskInformationSendOut",
    "ProcessTaskInviteToPlatform",
    "ProcessTaskReminder",
    "ProcessTaskUpload",
    "ProcessTaskWork",
    "ProcessTaskDocumentCheck",
    "ProcessTaskOrganizationAudit",
    "ProcessTaskRoleSetup",
    "ProcessTaskAutoOperation",
    "ProcessTaskTriggerEvent",
    "ProcessTaskAssignmentException",
    "ProcessTaskEmailSend",
    "ProcessTaskInformationCollection",
    "ProcessTaskUpdateCandidateProfile",
    "ProcessTaskPdfFormGeneration",
    "ProcessTaskOnlineApplication",
    "ProcessTaskEnterMissingInformation",
    "ProcessTaskEnterMissingInformationV2",
    "ProcessTaskDeactivateProcess",
    "ProcessTaskTranslateDocuments",
    "ProcessTaskUploadAvatar",
    "ProcessTaskInterviewWrite",
    "ProcessTaskEducationAssignToExam",
    "ProcessTaskEducationEnterExamResult",
    "ProcessTaskSigning",
  ]),
  ProcessState: RequiredTypeNames<ProcessStateFragment>()([
    "ProcessStateInformationSendOut",
    "ProcessStateInviteToPlatform",
    "ProcessStateReminder",
    "ProcessStateUpload",
    "ProcessStateWork",
    "ProcessStateDocumentCheck",
    "ProcessStateOrganizationAudit",
    "ProcessStateRoleSetup",
    "ProcessStateAutoOperation",
    "ProcessStateAssignmentException",
    "ProcessStateEmailSend",
    "ProcessStateInformationCollection",
    "ProcessStateUpdateCandidateProfile",
    "ProcessStatePdfFormGeneration",
    "ProcessStateOnlineApplication",
    "ProcessStateEnterMissingInformation",
    "ProcessStateEnterMissingInformationV2",
    "ProcessStateDeactivateProcess",
    "ProcessStateTranslateDocuments",
    "ProcessStateUploadAvatar",
    "ProcessStateInterviewWrite",
    "ProcessStateEducationAssignToExam",
    "ProcessStateEducationEnterExamResult",
    "ProcessStateSigning",
  ]),
  DocumentConfigurationBase: ["DocumentConfigurationDE", "DocumentConfigurationAT"],
  ProcessOperationResult: [
    "ProcessOperationCreateProcess",
    "ProcessOperationCreateDelegation",
    "ProcessOperationRemoveFromList",
    "ProcessOperationAddToList",
  ],
  BillingAccountResult: ["BillingAccount", "BillingAccountCandidate"],
  GenerateTemplateReportEvent: ["GenerateTemplateReportResult", "ProgressEvent"],
  XLSXTemplateResultEvent: ["XLSXTemplateResult", "ProgressEvent"],
  XLSXImportResultEvent: ["XLSXImportResult", "ProgressEvent"],
  XLSXImportResultForDocumentImportEvent: ["XLSXImportResultForDocumentImport", "ProgressEvent"],
  ImportUploadUrlResultEvent: ["ImportUploadUrlResult", "ProgressEvent"],
  UsedVariablesDownloadEvent: ["UsedVariablesDownload", "ProgressEvent"],
  ProcessPlanningResultEvent: ["ProcessPlanningListResult", "ProgressEvent"],
  PublishedProcessModelResultEvent: ["PublishedProcessModelEntity", "ProgressEvent"],
  RequiredDocumentOverviewEvent: ["RequiredDocumentOverview", "ProgressEvent"],
  OnlineApplicationValidationEvent: ["OnlineApplicationResult", "ProgressEvent"],
  OnlineApplicationExecutionEvent: ["OnlineApplicationExecutionResult", "ProgressEvent"],
  ProcessResultEvent: ["Process", "ProgressEvent"],
  ProcessListResultEvent: ["ProcessListResult", "ProgressEvent"],
  MutationResultEvent: ["MutationResult", "ProgressEvent"],
};
